import { gdpr as base } from './base';
import { gdpr as AT } from './AT';
import { gdpr as HR } from './HR';

export const featureConfigMap = {
    base,
    AT,
    HR,
};
